import { Injectable } from '@angular/core';
import { ApiNameList } from '../../../../environments/api-name-list';
import { HomeService } from '../home.service';
import { HttpClientService } from '../http-client-service';

@Injectable()
export class WaiverService {
    public baseUrl = '';
    constructor(public httpClientService: HttpClientService, private homeService: HomeService) {
        this.baseUrl = ApiNameList.restApi.baseUrl;
    }

    async getTerms(participationId: number) {
        let terms = null;
        const response: any = await this.homeService.getLandingData(participationId);
        if(response && response.terms && response.terms.length > 0) {
            terms = response.terms;
        }
        return terms;
    }

    getInsuranceCarriers(id: number, provider: number, otherProviderSupport: number): any {
        const body = {
            customProvider: provider,
            participationId: id,
            otherProviderSupport
        };
        return this.httpClientService.post(this.baseUrl + ApiNameList.restApi.getInsuranceCarriers, body);
    }

    getWaiverInfo(Id): any {
        const body = {
            participationId: Id
            };
        return this.httpClientService.post(this.baseUrl + ApiNameList.restApi.getWaiverInfo, body);
    }

    waiverReview(request: any) {
        return this.httpClientService.post(this.baseUrl + ApiNameList.restApi.waiverReview, request);
    }

    submitWaiver(request: {enrollmentId: number, termId: number, participationId: number}) {
        return this.httpClientService.post(this.baseUrl + ApiNameList.restApi.submitWaiver, request);
    }

    reValidateWaiver(request: {enrollmentId: number, termId: number, participationId: number}) {
        return this.httpClientService.post(this.baseUrl + ApiNameList.restApi.reValidateWaiver, request);
    }

    getFileLabelFormat() {
        return this.httpClientService.post(this.baseUrl + ApiNameList.restApi.getFileLabelFormat, { label: "waiver_file_name" });
    }
}
